<template>
    <div class="posts-wrapper">
      <div class="packages orders">

        <div :class="['wrap-boxes',{'wrap-opacity': boxActive != null}]">
          <template v-for="(stat, index) in ordersStats">
          <div :class="['box st-' +stat.st01Code,{'active': boxActive == stat.st01Code}]" @click="filterPackages(stat.st01Code)" :key="index">
            <span>{{stat.count}}</span>
            <p>{{stat.statusName}}</p>
          </div>
          </template>
        </div>

        <div class="box-white-wrapper">
          <vs-table :data="orders" pagination search max-items="50">
                <template slot="header" v-if="userInfoData.role == Roles.Admin">
                    <vs-button color="primary" to="/create-order" type="border" icon="library_add" style="margin-right: 15px">Crear Orden</vs-button>
                </template>
                <template slot="thead">
                    <vs-th sort-key="id">Id</vs-th>
                    <vs-th sort-key="notes">Nombre</vs-th>
                    <vs-th sort-key="qtyPkgs">Qty Paquetes </vs-th>
                    <vs-th sort-key="qty">Solicitante </vs-th>
                    <vs-th sort-key="status">Estado </vs-th>
                    <vs-th sort-key="createdAt"> Fecha </vs-th>
                    <vs-th sort-key="id" class="width-30"></vs-th>
                </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].id">{{data[indextr].id }}</vs-td>
                    <vs-td :data="data[indextr].notes">{{data[indextr].notes }}</vs-td>
                    <vs-td :data="data[indextr].applicant">{{data[indextr].qtyPkgs }}</vs-td>
                    <vs-td :data="data[indextr].applicant">{{data[indextr].applicantUser.name + " " + data[indextr].applicantUser.lastname }}</vs-td>
                    <vs-td :data="data[indextr].applicant">{{data[indextr].status.name }}</vs-td>
                    <vs-td :data="data[indextr].createdAt">{{data[indextr].createdAt | moment('lll') }}</vs-td> 
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                            <router-link :to="`/order-detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                        </div>
                    </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import { required } from 'vuelidate/lib/validators'
import InventoryService from "@/services/InventoryService"

export default {
  name: 'Inventories',
  mixins: [helper],
  data () {
    return {
      customer: {},
      customers:[],
      invId: '',
      orders: [],
      ordersStats: [],
      boxActive: null
    }
  },
  created(){
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.getOrders();
    // this.retrievePackages()
  },
  validations: {
    package: 
      { 
        status: { required },
      },
  },
  methods: {
    getOrders() {
        InventoryService.getOrders()
        .then(response => {
            console.log(response);
            this.orders = response.data.records;
            this.ordersStats = response.data.stats;
            this.$Progress.finish()
        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
        //   this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
        //   this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    }
  }
}
</script>
